import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import { getComicsByCategory } from '@/mocks/comics';
import { categories } from '@/mocks/categories';
import NotFound from '@/pages/NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryComics = getComicsByCategory(slug || '');
  const category = categories.find((c) => c.slug === slug);

  if (!category || categoryComics.length === 0) {
    return <NotFound />;
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://heiliaoapp.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: category.name,
        item: `http://heiliaoapp.cn/category/${category.slug}`,
      },
    ],
  };

  const collectionSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 073漫画网`,
    description: category.description,
    url: `http://heiliaoapp.cn/category/${category.slug}`,
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: category.name },
              ]}
            />

            <div className="py-8">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                    {category.name}
                  </h1>
                  <p className="text-sm text-foreground-500 mt-1">
                    共 {category.count} 部作品 · {category.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2 rounded-full text-sm font-label transition-all whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5 pb-16" data-product-shop="">
              {categoryComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}